var map = {
	"./de_DE.json": 1068,
	"./en_AU.json": 1069,
	"./en_CA.json": 1070,
	"./en_GB.json": 1071,
	"./es_AR.json": 1072,
	"./es_ES.json": 1073,
	"./es_MX.json": 1074,
	"./fr_CA.json": 1075,
	"./fr_FR.json": 1076,
	"./it_IT.json": 1077,
	"./nl_NL.json": 1078,
	"./pt_BR.json": 1079,
	"./pt_PT.json": 1080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1067;